module.exports = __webpack_public_path__ + "static/media/contest2025_fourth_place_profileImage.537c7c72.jpeg";